var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBlock = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.03125C4.18359 0.03125 0.28125 3.96875 0.28125 8.75C0.28125 13.5664 4.18359 17.4688 9 17.4688C13.7812 17.4688 17.7188 13.5664 17.7188 8.75C17.7188 3.96875 13.7812 0.03125 9 0.03125ZM13.5703 4.17969C15.8555 6.5 16.0312 10.0156 14.2734 12.4766L5.27344 3.47656C7.73438 1.71875 11.25 1.89453 13.5703 4.17969ZM4.39453 13.3555C2.10938 11.0352 1.93359 7.51953 3.69141 5.05859L12.6914 14.0586C10.2305 15.8164 6.71484 15.6406 4.39453 13.3555Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/block.04515587.svg";
export { ForwardRef as ReactComponent };